<div class="custom_tab_body" style="height: 100%;">
    <div style="height: 5%;width: 100%;">
        <div fxFlex="100" class="header_div_sm">
            Shipping Manager
            <button *ngIf="pickedUpShippingData.length > 0" type="button" id="start_btn_sm"
                (click)="onStartClick()">S</button>
        </div>
    </div>

    <div style="width: 100%;overflow: auto;" [style.height.%]="isShowMap ? '89' : 95">
        <div class="parent_div_sm">
            <div *ngFor="let shipping of shippingDetailsList;let i= index"
                class="col-md-12 col-sm-12 col-12 cart_div_sm">
                <div class="status_div_sm" [style.background-color]="shipping.assignedDeliveryDto.status == constant.ASSIGNED ? '#5f5f5f' : shipping.assignedDeliveryDto.status == constant.RE_ASSIGNED ? '#B8860B'
                     : shipping.assignedDeliveryDto.status == constant.DELIVERY_PICK_UP ? '#228B22' : shipping.assignedDeliveryDto.status == constant.DELIVERY_CANCEL ? '#B22222'
                     : shipping.assignedDeliveryDto.status == constant.DELIVERED ? '#1976D2' : '#5f5f5f'">
                    <div style="width: 50%;text-align: left;font-size: 13px;">
                        <span style="margin-left: 4%;">{{shipping.assignedDeliveryDto?.transType}}</span>
                        <span style="margin-left: 4%;">{{shipping.assignedDeliveryDto?.status}}</span>
                    </div>
                    <div class="img_div_sm">
                        <span *ngIf="shipping.assignedDeliveryDto.status == constant.DELIVERY_PICK_UP && isShowMap"
                            class="img_span_sm" (click)="onStatusClick(shipping,constant.DELIVERED)">
                            <img src="./assets/images/ic_deliver.svg" alt="icon" class="img_size_sm"
                                matTooltip="Deliver" />
                        </span>
                        <span *ngIf="shipping.assignedDeliveryDto.status == constant.DELIVERY_PICK_UP && isShowMap"
                            class="img_span_sm" (click)="onStatusClick(shipping,constant.DELIVERY_CANCEL)">
                            <img src="./assets/images/ic_cancel_delivery.svg" alt="icon" class="img_size_sm"
                                matTooltip="Cancel" />
                        </span>
                        <span *ngIf="(shipping.assignedDeliveryDto?.status == constant.DELIVERY_CANCEL || shipping.assignedDeliveryDto?.status == constant.DELIVERED)
                        " class="img_span_sm" (click)="onRatingClick(shipping)">
                            <img src="./assets/images/ic_rating.svg" alt="icon" class="img_size_sm"
                                matTooltip="Rating" />
                        </span>
                        <span *ngIf="(shipping.assignedDeliveryDto.status == constant.RIDER_ACCEPTED)
                        && isShowAsignBtn" class="img_span_sm" matTooltip="Pick Up"
                            (click)="onStatusClick(shipping,constant.DELIVERY_PICK_UP)">
                            <img src="./assets/images/ic_pickup_parcel.svg" alt="icon" class="img_size_sm" />
                        </span>

                        <span *ngIf="shipping.assignedDeliveryDto.status == constant.DELIVERY_PICK_UP"
                            class="img_span_sm" (click)="onStatusClick(shipping,constant.DELIVERY_PICK_UP_CANCELLED)"
                            matTooltip="Pick Up Cancel">
                            <img src="./assets/images/ic_cancel_pick_up.svg" alt="icon" class="img_size_sm" />
                        </span>
                        <span *ngIf="shipping.assignedDeliveryDto.status == constant.DELIVERY_PICK_UP  && isShowMap"
                            class="img_span_sm" (click)="onStatusClick(shipping,constant.DELIVERY_RESCHEDULE)">
                            <img src="./assets/images/ic_res.svg" alt="icon" class="img_size_sm"
                                matTooltip="Re Schedule" />
                        </span>


                    </div>
                </div>
                <div class="details_div_sm" (click)="onDetailsClick(shipping)">
                    <p>Transaction No : {{shipping.assignedDeliveryDto?.invNo}}</p>
                    <p>Transaction Date : {{shipping.allOrdersForDeliveryDto?.invoiceDate | date: 'yyyy-MM-dd
                        hh:mm:ss'}}</p>
                    <p>Amount : {{shipping.allOrdersForDeliveryDto.netAmt | number : '1.2-2'}}</p>
                    <p>Total Items : {{shipping.noOfProducts}}</p>
                    <p>Total Qty : {{shipping.qty}}</p>
                    <p>Shipping Date : {{shipping.assignedDeliveryDto?.deliveryDate | date: 'yyyy-MM-dd'}}</p>
                    <p>Slot Time : {{shipping.assignedDeliveryDto?.slot}}</p>
                </div>
                <div class="footer_div_sm">
                    <p>{{shipping.customerDeliveryDetails?.shippingPlotNo}},
                        {{shipping.customerDeliveryDetails?.shippingStreet}}</p>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isShowMap" [ngClass]="opencart ? 'open_cart_sm' : 'close_cart_sm'">
        <div class="display_container_sm">
            <div class="display_holder_sm" (click)="opencart = !opencart" (touchstart)="opencart = !opencart">
                <span class="display_detail_sm">Map
                    <mat-icon>map</mat-icon>
                </span>
            </div>
        </div>

        <div style="height: 380px;background: white;overflow: auto;">
            <div class="container">
                <div style="padding: 10px 0 10px 0;">
                    <!--  <input type="text" class="form-control" (keydown.enter)="$event.preventDefault()"
                        placeholder="Search Nearest Location" autocorrect="off" autocapitalize="off" spellcheck="off"
                        type="text" #search> -->
                </div>
                <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
                    <agm-direction [origin]="origin" [destination]="destination" [waypoints]="waypoints"
                        [renderOptions]="renderOptions" [markerOptions]="markerOptions">
                    </agm-direction>
                </agm-map>
                
            </div>
        </div>
    </div>
</div>